import React from 'react';
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';

const propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

const Logo = ({ src, alt = '', ...props }) => (
  <S.Logo>
    <img src={src} alt={alt} {...props} />
  </S.Logo>
);

Logo.propTypes = propTypes;

export default Logo;
